import { render, staticRenderFns } from "./BlackHoleTab.vue?vue&type=template&id=fb09ce3a&scoped=true"
import script from "./BlackHoleTab.vue?vue&type=script&lang=js"
export * from "./BlackHoleTab.vue?vue&type=script&lang=js"
import style0 from "./BlackHoleTab.vue?vue&type=style&index=0&id=fb09ce3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb09ce3a",
  null
  
)

export default component.exports